<div class="content" *ngIf="false">

  <div style="flex: 1"></div>

</div>

<div class="content">
  <header role="header" style="height: 100%">
    <nav role="navigation"  style="height: 100%">
      <div class="client">
        <img class="img-fluid img " *ngIf="false" src="./assets/img/client.png" alt="logo">
        <img class="img-fluid img flag"  src="./assets/img/flag.png" alt="flag">
        <img class="img-fluid img republic" style="float: right" src="./assets/img/republic_senegal.png" alt="republique du senegale">

      </div>
      <div class="menu">
        <div class="mobile_menu">
          <a class="menu-item" routerLinkActive="active" (click)="shownav()">
            <span>
          <svg _ngcontent-syh-c51="" width="30" height="30" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path _ngcontent-syh-c51="" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </span>
        </a>
        </div>
        <div class="large_menu">
          <a class="menu-item" routerLink="home" routerLinkActive="active">
            <span>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.15722 19.7714V16.7047C8.1572 15.9246 8.79312 15.2908 9.58101 15.2856H12.4671C13.2587 15.2856 13.9005 15.9209 13.9005 16.7047V16.7047V19.7809C13.9003 20.4432 14.4343 20.9845 15.103 21H17.0271C18.9451 21 20.5 19.4607 20.5 17.5618V17.5618V8.83784C20.4898 8.09083 20.1355 7.38935 19.538 6.93303L12.9577 1.6853C11.8049 0.771566 10.1662 0.771566 9.01342 1.6853L2.46203 6.94256C1.86226 7.39702 1.50739 8.09967 1.5 8.84736V17.5618C1.5 19.4607 3.05488 21 4.97291 21H6.89696C7.58235 21 8.13797 20.4499 8.13797 19.7714V19.7714" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
              </a>
              <a class="menu-item"  routerLink="map" routerLinkActive="active" ><span>{{'HEADER.MAP' | translate}}</span></a>
              <a class="menu-item"  routerLink="documents" routerLinkActive="active">
                <span>{{'HEADER.DOCUMENTS' | translate}}</span></a>
              <a class="menu-item"  (click)="login()">
                <span >{{'HEADER.LOGIN' | translate}}</span>
              </a>
              <a class="menu-item"  (click)="changeLang()">
                <span >{{'HEADER.LANG' | translate}}</span>
              </a>
        </div>
      </div>
      <div class="nav_menu" *ngIf='nav_menu'>
        <div class="list_nav">
          <a class="menu-item" routerLink="home" routerLinkActive="active" (click)="shownav()">
            <span>
              <svg width="12" height="12" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.15722 19.7714V16.7047C8.1572 15.9246 8.79312 15.2908 9.58101 15.2856H12.4671C13.2587 15.2856 13.9005 15.9209 13.9005 16.7047V16.7047V19.7809C13.9003 20.4432 14.4343 20.9845 15.103 21H17.0271C18.9451 21 20.5 19.4607 20.5 17.5618V17.5618V8.83784C20.4898 8.09083 20.1355 7.38935 19.538 6.93303L12.9577 1.6853C11.8049 0.771566 10.1662 0.771566 9.01342 1.6853L2.46203 6.94256C1.86226 7.39702 1.50739 8.09967 1.5 8.84736V17.5618C1.5 19.4607 3.05488 21 4.97291 21H6.89696C7.58235 21 8.13797 20.4499 8.13797 19.7714V19.7714" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </a>
          <a class="menu-item"  routerLink="map" routerLinkActive="active" (click)="shownav()"><span>{{'HEADER.MAP' | translate}}</span></a>
          <a class="menu-item"  routerLink="documents" routerLinkActive="active" (click)="shownav()">
                  <span>{{'HEADER.DOCUMENTS' | translate}}</span></a>
          <a class="menu-item"  (click)="login()" (click)="shownav()">
                  <span >{{'HEADER.LOGIN' | translate}}</span>
          </a>
          <a class="menu-item"  (click)="changeLang()">
                  <span >{{'HEADER.LANG' | translate}}</span>
          </a>
        </div>
      </div>
    </nav>
  </header>
</div>
